import moment from "moment";

const convertToUTC = date => {
  return moment(date)
    .utc()
    .format();
};

export default convertToUTC;
